export default __webpack_public_path__ + "static/Packaging_Anatomy-9091cb6a5cd4b8374d45aa5b2d429217.png";